export const headerBundle = {
  label: { ko: "운영 세대", en: "Active Households", es: "Hogares activos" },
  unit: { ko: "세대", en: "households", es: "hogares" },
  caption: {
    ko: "모니터링"
  }
}
